import React from 'react';
import PropTypes from 'prop-types';
import Edit from '@material-ui/icons/Edit';
import { Link } from 'react-router-dom';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import ContentCard from 'components/ContentCard/ContentCard';
import MobileProfileAttributes from 'components/MobileProfileAttributes/MobileProfileAttributes';
import routeDefinitions from 'enum/routeDefinitions';
import { shouldShowEditButton } from 'utils/helpers';

import styles from './Attributes.css';


const Attributes = (props) => {
  const { history } = props;
  const { user } = UserStore;
  const { profileName } = ProfileStore;

  const route = routeDefinitions.get(routeDefinitions.profileSettingsRoutes.info, { username: user.username });
  const title = shouldShowEditButton(user, profileName) ? (
    <div className={styles.flexContainer}>
      <div>{translate('v2profile.profile.attributes')}</div>
      <Link to={route}>
        <Edit className={styles.editIcon} />
      </Link>
    </div>
  ) : (
    translate('v2profile.profile.attributes')
  );

  return (
    <div>
      <ContentCard title={title}>
        <MobileProfileAttributes history={history} noMargin={true} showHeader={false} />
      </ContentCard>
    </div>
  );
};

Attributes.propTypes = { history: PropTypes.object.isRequired };

export default Attributes;
